<template>
  <div class="container logged-out-content">
    <form class="block form-sm" name="forgotUsernameForm" @submit.prevent="requestUsernameReminder()">
      <header>
        <div class="pull-left">
          <div class="icon">
            <img src="~assets/images/Patient-Icon.png">
          </div>
        </div>
        <div class="col-xs-9">
          <h2>Forgotten Username</h2>
        </div>
      </header>

      <div class="subheader" v-if="!requestComplete">
        <p>Please enter your email address below</p>
        <p><i class="glyphicon glyphicon-asterisk"></i> indicates a required field</p>
      </div>
      <div v-if="!requestComplete">
        <error-display v-if="errorMessage">{{errorMessage}}</error-display>
        <div class="content">
          <div class="row">
            <input-text name="email" label="Email Address" v-model="emailAddress" :validation="$v.emailAddress"></input-text>
          </div>
        </div>
        <div class="footer">
          <div class="col-xs-12 pointer text-center">
            <submit-button id="request-username-reminder-submit" :loading="loading">Request Reminder</submit-button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="content" v-if="requestComplete">
        <p>If a user with this email address exists, then an email will be sent to their registered email address with a username
          reminder</p>
      </div>
    </form>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators';
  import InputText from 'components/common/inputs/InputText';
  import SubmitButton from 'components/common/buttons/SubmitButton';
  import ErrorDisplay from 'components/common/outputs/ErrorDisplay';

  export default {
    name: 'forgot-username',
    components: {
      InputText,
      SubmitButton,
      ErrorDisplay,
    },
    data: () => ({
      loading: false,
      errorMessage: '',
      emailAddress: '',
      requestComplete: false,
    }),
    validations: {
      emailAddress: {
        required,
        email,
      },
    },
    methods: {
      async requestUsernameReminder() {
        try {
          this.loading = true;

          await this.$api.requestUsernameReminder({
            email: this.emailAddress,
          });

          this.requestComplete = true;
        } catch (error) {
          this.errorMessage = this.$api.processError(error);
        } finally {
          this.loading = false;
        }
      },
    },
    mounted() {
      // If no context is found, set context to patient
      if (this.$store.state.context === '') {
        this.$store.dispatch('updateContext', {
          context: 'patient',
        });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// ForgotUsername.vue?6a6dc67f